import type { Space } from '@mock-sensors/api-client';

/** This UI's space (docs/SPACES.md): `/pro/…` is the pro simulator, anything else ambient. */
export const SPACE: Space = window.location.pathname.split('/')[1] === 'pro' ? 'pro' : 'ambient';

/** For headings: "Ambient" or "Pro". */
export const SPACE_LABEL = SPACE === 'pro' ? 'Pro' : 'Ambient';

/** Where this space's admin UI lives (the router's basename). */
export const BASENAME = `/${SPACE}/manage`;

/** The space's own page (`/ambient` or `/pro`). */
export const SPACE_PAGE = `/${SPACE}`;

/** The first Modbus unit id of the space's range (pro 1–127, ambient 128–247). */
export const FIRST_UNIT = SPACE === 'pro' ? 1 : 128;
